// extracted by mini-css-extract-plugin
export var body = "best-ai-sdr-for-b2b-saas-module--body--1ae35";
export var bullets = "best-ai-sdr-for-b2b-saas-module--bullets--137e1";
export var byline = "best-ai-sdr-for-b2b-saas-module--byline--16280";
export var bylineAvatar = "best-ai-sdr-for-b2b-saas-module--bylineAvatar--ffab4";
export var bylineLine = "best-ai-sdr-for-b2b-saas-module--bylineLine--91bc1";
export var bylineMeta = "best-ai-sdr-for-b2b-saas-module--bylineMeta--b588a";
export var bylineName = "best-ai-sdr-for-b2b-saas-module--bylineName--81c7b";
export var bylineSection = "best-ai-sdr-for-b2b-saas-module--bylineSection--29240";
export var callout = "best-ai-sdr-for-b2b-saas-module--callout--956d0";
export var calloutCta = "best-ai-sdr-for-b2b-saas-module--calloutCta--47535";
export var caption = "best-ai-sdr-for-b2b-saas-module--caption--34c9e";
export var container = "best-ai-sdr-for-b2b-saas-module--container--95a6e";
export var ctaButtons = "best-ai-sdr-for-b2b-saas-module--ctaButtons--cd67d";
export var ctaCallout = "best-ai-sdr-for-b2b-saas-module--ctaCallout--d04b8";
export var ctaSection = "best-ai-sdr-for-b2b-saas-module--ctaSection--37908";
export var evalBody = "best-ai-sdr-for-b2b-saas-module--evalBody--7accc";
export var evalCard = "best-ai-sdr-for-b2b-saas-module--evalCard--7e6d8";
export var evalGrid = "best-ai-sdr-for-b2b-saas-module--evalGrid--1ec11";
export var evalIcon = "best-ai-sdr-for-b2b-saas-module--evalIcon--ecb77";
export var evalList = "best-ai-sdr-for-b2b-saas-module--evalList--18ebe";
export var evalNum = "best-ai-sdr-for-b2b-saas-module--evalNum--54310";
export var evalTitle = "best-ai-sdr-for-b2b-saas-module--evalTitle--ff21e";
export var faqItem = "best-ai-sdr-for-b2b-saas-module--faqItem--29bd8";
export var faqList = "best-ai-sdr-for-b2b-saas-module--faqList--6f59d";
export var faqQ = "best-ai-sdr-for-b2b-saas-module--faqQ--f1d93";
export var featuredRow = "best-ai-sdr-for-b2b-saas-module--featuredRow--61903";
export var freeCard = "best-ai-sdr-for-b2b-saas-module--freeCard--2fe56";
export var freeCardType = "best-ai-sdr-for-b2b-saas-module--freeCardType--78470";
export var freeGrid = "best-ai-sdr-for-b2b-saas-module--freeGrid--78234";
export var glanceBadge = "best-ai-sdr-for-b2b-saas-module--glanceBadge--dea95";
export var glanceEyebrow = "best-ai-sdr-for-b2b-saas-module--glanceEyebrow--d945d";
export var glanceHeader = "best-ai-sdr-for-b2b-saas-module--glanceHeader--feec3";
export var glancePick = "best-ai-sdr-for-b2b-saas-module--glancePick--7ab3a";
export var glancePickName = "best-ai-sdr-for-b2b-saas-module--glancePickName--c226d";
export var glancePickPositioning = "best-ai-sdr-for-b2b-saas-module--glancePickPositioning--2873f";
export var glancePicks = "best-ai-sdr-for-b2b-saas-module--glancePicks--968d0";
export var h1 = "best-ai-sdr-for-b2b-saas-module--h1--3c2d2";
export var h2 = "best-ai-sdr-for-b2b-saas-module--h2--e6399";
export var h3 = "best-ai-sdr-for-b2b-saas-module--h3--28b5a";
export var h4 = "best-ai-sdr-for-b2b-saas-module--h4--e6b83";
export var hero = "best-ai-sdr-for-b2b-saas-module--hero--d13be";
export var heroByline = "best-ai-sdr-for-b2b-saas-module--heroByline--6213b";
export var heroBylineSep = "best-ai-sdr-for-b2b-saas-module--heroBylineSep--c1c8b";
export var heroCentered = "best-ai-sdr-for-b2b-saas-module--heroCentered--27371";
export var heroCopy = "best-ai-sdr-for-b2b-saas-module--heroCopy--c6772";
export var heroCta = "best-ai-sdr-for-b2b-saas-module--heroCta--b9b12";
export var heroGrid = "best-ai-sdr-for-b2b-saas-module--heroGrid--e3502";
export var heroMeta = "best-ai-sdr-for-b2b-saas-module--heroMeta--e2096";
export var heroMetaSep = "best-ai-sdr-for-b2b-saas-module--heroMetaSep--8e2eb";
export var heroVisual = "best-ai-sdr-for-b2b-saas-module--heroVisual--10441";
export var ioTable = "best-ai-sdr-for-b2b-saas-module--ioTable--c762e";
export var lead = "best-ai-sdr-for-b2b-saas-module--lead--8e5ea";
export var linkInline = "best-ai-sdr-for-b2b-saas-module--linkInline--b7b54";
export var linkInlineLight = "best-ai-sdr-for-b2b-saas-module--linkInlineLight--d5564";
export var matrix = "best-ai-sdr-for-b2b-saas-module--matrix--31c65";
export var matrixCol = "best-ai-sdr-for-b2b-saas-module--matrixCol--8ac98";
export var moreCard = "best-ai-sdr-for-b2b-saas-module--moreCard--729b7";
export var moreCardBestFor = "best-ai-sdr-for-b2b-saas-module--moreCardBestFor--5f9c1";
export var moreCardHeader = "best-ai-sdr-for-b2b-saas-module--moreCardHeader--0e026";
export var moreCardMeta = "best-ai-sdr-for-b2b-saas-module--moreCardMeta--e6531";
export var moreCardName = "best-ai-sdr-for-b2b-saas-module--moreCardName--19899";
export var moreCardTagline = "best-ai-sdr-for-b2b-saas-module--moreCardTagline--72230";
export var moreGrid = "best-ai-sdr-for-b2b-saas-module--moreGrid--8b8e9";
export var motionBadge = "best-ai-sdr-for-b2b-saas-module--motionBadge--c408c";
export var motionHybrid = "best-ai-sdr-for-b2b-saas-module--motionHybrid--c7bf3";
export var motionInbound = "best-ai-sdr-for-b2b-saas-module--motionInbound--f574f";
export var motionOutbound = "best-ai-sdr-for-b2b-saas-module--motionOutbound--38c83";
export var outcomeCard = "best-ai-sdr-for-b2b-saas-module--outcomeCard--9966b";
export var outcomeMetric = "best-ai-sdr-for-b2b-saas-module--outcomeMetric--6eb98";
export var outcomeStack = "best-ai-sdr-for-b2b-saas-module--outcomeStack--30e50";
export var outcomesLine = "best-ai-sdr-for-b2b-saas-module--outcomesLine--19a56";
export var pcCheck = "best-ai-sdr-for-b2b-saas-module--pcCheck--2789b";
export var pcCross = "best-ai-sdr-for-b2b-saas-module--pcCross--f5d3b";
export var pill = "best-ai-sdr-for-b2b-saas-module--pill--5aa0f";
export var pillar = "best-ai-sdr-for-b2b-saas-module--pillar--f21fa";
export var pricingCard = "best-ai-sdr-for-b2b-saas-module--pricingCard--6fe49";
export var pricingExamples = "best-ai-sdr-for-b2b-saas-module--pricingExamples--0673c";
export var pricingGrid = "best-ai-sdr-for-b2b-saas-module--pricingGrid--a13bc";
export var pricingTco = "best-ai-sdr-for-b2b-saas-module--pricingTco--1b391";
export var relatedHub = "best-ai-sdr-for-b2b-saas-module--relatedHub--99390";
export var relatedHubGrid = "best-ai-sdr-for-b2b-saas-module--relatedHubGrid--2353f";
export var relatedHubTag = "best-ai-sdr-for-b2b-saas-module--relatedHubTag--0991b";
export var rolloutAction = "best-ai-sdr-for-b2b-saas-module--rolloutAction--1fe8e";
export var rolloutActionList = "best-ai-sdr-for-b2b-saas-module--rolloutActionList--35927";
export var rolloutGrid = "best-ai-sdr-for-b2b-saas-module--rolloutGrid--ce047";
export var rolloutMap = "best-ai-sdr-for-b2b-saas-module--rolloutMap--1c129";
export var rolloutPhase = "best-ai-sdr-for-b2b-saas-module--rolloutPhase--85707";
export var rolloutPhaseKpi = "best-ai-sdr-for-b2b-saas-module--rolloutPhaseKpi--62812";
export var rolloutPhaseLabel = "best-ai-sdr-for-b2b-saas-module--rolloutPhaseLabel--b4556";
export var rolloutPhaseNode = "best-ai-sdr-for-b2b-saas-module--rolloutPhaseNode--8bbf8";
export var rolloutPhaseTitle = "best-ai-sdr-for-b2b-saas-module--rolloutPhaseTitle--d7f36";
export var section = "best-ai-sdr-for-b2b-saas-module--section--5a274";
export var stageCard = "best-ai-sdr-for-b2b-saas-module--stageCard--18ce4";
export var stageGrid = "best-ai-sdr-for-b2b-saas-module--stageGrid--0de41";
export var stageLabel = "best-ai-sdr-for-b2b-saas-module--stageLabel--4fa23";
export var stageTools = "best-ai-sdr-for-b2b-saas-module--stageTools--b7a5e";
export var stageWatchOut = "best-ai-sdr-for-b2b-saas-module--stageWatchOut--30090";
export var statBand = "best-ai-sdr-for-b2b-saas-module--statBand--0e018";
export var statCell = "best-ai-sdr-for-b2b-saas-module--statCell--e1de2";
export var statFootnote = "best-ai-sdr-for-b2b-saas-module--statFootnote--4e0cf";
export var statGrid = "best-ai-sdr-for-b2b-saas-module--statGrid--ecfbe";
export var statLabel = "best-ai-sdr-for-b2b-saas-module--statLabel--d63c3";
export var statNum = "best-ai-sdr-for-b2b-saas-module--statNum--d6131";
export var subPillarCard = "best-ai-sdr-for-b2b-saas-module--subPillarCard--442f0";
export var subPillarComingSoon = "best-ai-sdr-for-b2b-saas-module--subPillarComingSoon--aeed2";
export var subPillarDesc = "best-ai-sdr-for-b2b-saas-module--subPillarDesc--3ea01";
export var subPillarGrid = "best-ai-sdr-for-b2b-saas-module--subPillarGrid--cdb79";
export var subPillarMeta = "best-ai-sdr-for-b2b-saas-module--subPillarMeta--af45b";
export var tableWrap = "best-ai-sdr-for-b2b-saas-module--tableWrap--223f3";
export var tldrTable = "best-ai-sdr-for-b2b-saas-module--tldrTable--99b0b";
export var toolName = "best-ai-sdr-for-b2b-saas-module--toolName--a05d6";
export var top6BestFor = "best-ai-sdr-for-b2b-saas-module--top6BestFor--91f59";
export var top6Card = "best-ai-sdr-for-b2b-saas-module--top6Card--965e8";
export var top6Featured = "best-ai-sdr-for-b2b-saas-module--top6Featured--a2f22";
export var top6Footer = "best-ai-sdr-for-b2b-saas-module--top6Footer--07492";
export var top6Grid = "best-ai-sdr-for-b2b-saas-module--top6Grid--479b2";
export var top6Header = "best-ai-sdr-for-b2b-saas-module--top6Header--26244";
export var top6LogoBox = "best-ai-sdr-for-b2b-saas-module--top6LogoBox--04648";
export var top6LogoInitials = "best-ai-sdr-for-b2b-saas-module--top6LogoInitials--be7f2";
export var top6Meta = "best-ai-sdr-for-b2b-saas-module--top6Meta--15a02";
export var top6Name = "best-ai-sdr-for-b2b-saas-module--top6Name--ed24b";
export var top6PcCol = "best-ai-sdr-for-b2b-saas-module--top6PcCol--8d88e";
export var top6PcIcon = "best-ai-sdr-for-b2b-saas-module--top6PcIcon--c39b2";
export var top6PcLabel = "best-ai-sdr-for-b2b-saas-module--top6PcLabel--b3cef";
export var top6PcList = "best-ai-sdr-for-b2b-saas-module--top6PcList--6ae58";
export var top6Position = "best-ai-sdr-for-b2b-saas-module--top6Position--e61bd";
export var top6Pricing = "best-ai-sdr-for-b2b-saas-module--top6Pricing--7ef46";
export var top6PricingLabel = "best-ai-sdr-for-b2b-saas-module--top6PricingLabel--884e7";
export var top6PricingTable = "best-ai-sdr-for-b2b-saas-module--top6PricingTable--c7756";
export var top6ProsCons = "best-ai-sdr-for-b2b-saas-module--top6ProsCons--71abf";
export var verticalCard = "best-ai-sdr-for-b2b-saas-module--verticalCard--4d2e0";
export var verticalGrid = "best-ai-sdr-for-b2b-saas-module--verticalGrid--69c64";